import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { RiskEvent } from "../../_interfaces/RiskEvent.model";
import { Router } from '@angular/router';
import { RepositoryService } from "../../shared/services/repository.service";

@Component({
  selector: 'app-risk-event-list',
  templateUrl: './risk-event-list.component.html',
  styleUrls: ['./risk-event-list.component.css']
})
export class RiskEventListComponent implements OnInit {

  @Input() public riskEvents: RiskEvent[];
  @Input() public allowDelete: boolean;
  @Output() messageToEmit = new EventEmitter<string>();

  constructor(
    private router: Router,
    public repository: RepositoryService
  ) { }

  ngOnInit() {

  }

  public getRiskEventDetails(riskEventId: number) {
    let riskDetailUrl: string = `/myrisks/riskevents/${riskEventId}`; 
    this.router.navigate([riskDetailUrl]);
  }

  public deleteRiskEvent(riskEventId: number) {
    if (this.allowDelete) {
      let riskDetailUrl: string = `riskevents/${riskEventId}`; 
      this.repository.delete(riskDetailUrl)
        .subscribe(res => {
          // Update the parent dialog contents to remove the deleted Risk Event 
          //this.getRiskEventDetails();
          this.messageToEmit.emit(`refresh`);
        });
    }
  }

}
